import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { PhysiologicalDataApi } from '../../../apis/PhysiologicalDataApi/PhysiologicalDataApi';
import { IUnit, Unit } from '../PhysiologicalData';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';

export function useGetPhysiologicalUnitsByType(typeId: number) {
    return useHighFrequencyRefreshQuery<IUnit[]>({
        queryKey: [QueryKeys.physiologicalUnits, typeId],
        queryFn: async () => {
            const results = await PhysiologicalDataApi.getPhysiologicalUnitsByType(typeId.toString());
            return results.map(result => new Unit(result));
        },
        enabled: !!typeId
    });
} 